/**
 * Moderation Cases Open Panel
 *
 * Displays the number of open moderation cases
 */

import { Shimmer, Text } from '@soteria/design-system-ve';

import * as styles from './ModerationStatsPanel.css';

interface ModerationCasesOpenPanelProps {
  casesOpen: number;
  isLoading?: boolean;
}

export function ModerationCasesOpenPanel({ casesOpen, isLoading = false }: ModerationCasesOpenPanelProps) {
  if (isLoading) {
    return (
      <div className={styles.panel}>
        <div className={styles.header}>
          <span className={styles.title}>CASES OPEN</span>
        </div>
        <div className={styles.content}>
          <Shimmer className={styles.shimmerValue} label="Loading cases open count" />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <span className={styles.title}>CASES OPEN</span>
      </div>
      <div className={styles.content}>
        <Text as="div" className={styles.value}>
          {casesOpen.toLocaleString()}
        </Text>
        <Text as="div" className={styles.subtitle}>
          Pending review
        </Text>
      </div>
    </div>
  );
}
